module.exports = __webpack_public_path__ + "mobile/img/cal_icon_w.c95f9b8c.svg";